import { Box, Container } from "@mui/material";

interface TabPanelProps {
    children?: React.ReactNode;
    tabType: string;
    value: string;
    className?: string;
}

const CustomTabPanel = (props: TabPanelProps) => {
    const { children, value, tabType, className, ...other } = props;

    return (
        <div
            className={className}
            role="tabpanel"
            hidden={value !== tabType}
            id={`custom-tabpanel-${tabType}`}
            aria-labelledby={`custom-${tabType}`}
            {...other}
        >
            {value === tabType && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
};

export default CustomTabPanel;
